//---------	Global imports
import React from 'react';

//---------	Plugins
import { filter, includes, forEach } from 'lodash';

//---------	Styles
import './styles.sass';

//---------	Translations
import { T } from '../../../translations';


class Faq extends React.Component {
  
  //---------	Constructor
  constructor(props) {
    super();
    
    this.state = {
      results: []
    };
    
    this.filterSearchTerm = this.filterSearchTerm.bind(this);
    this.populateResults = this.populateResults.bind(this);
  }
  
  
  //---------	React functions
  componentDidMount() {
    this.filterSearchTerm();
  }
  
  
  //---------	Custom functions
  toggleAnswer(e) {
    const question = e.target;
    const answer = question.nextElementSibling;
    
    $(question).toggleClass('state-active');
    $(answer).slideToggle(150);
  }
  
  filterSearchTerm(e) {
    const searchTerm = e ? e.target.value.toLowerCase() : '';
    const data = filter(T.faq.QA, (qa) => includes(qa.q.toLowerCase(), searchTerm));
    
    this.populateResults(data);
  }
  
  populateResults(data) {
    let results = [];
    
    if (data.length > 0) {
      forEach(data, (el, key) => {
        results.push(<div className="CalipsyFAQ-result" key={key}><h4 className="CalipsyFAQ-q"
                                                                      onClick={this.toggleAnswer}>{el.q}</h4>
          <div className="CalipsyFAQ-a" dangerouslySetInnerHTML={{__html: el.a}}></div>
        </div>);
      });
    } else {
      results.push(<div className="CalipsyFAQ-result state-fixed" key="contactus"><h4 className="CalipsyFAQ-q">We can't
        find any question related to your phrase :(</h4>
        <div className="CalipsyFAQ-a" style={{display: 'block'}}>We are more than happy to help you with any question
          related to our products or the website. You can contact us directly at <a href="mailto:hello@calipsy.com">hello@calipsy.com</a></div>
      </div>);
    }
    
    this.setState({results: results});
  }
  
  
  //---------	Render
  render() {
    return (
      
      <div className="CalipsyFAQ">
        <div className="CalipsyContainer">
          <h1>{T.faq.title}</h1>
          <h4>{T.faq.subtitle}</h4>
          
          <div className="CalipsyFAQ-filterBy">
            <input type="text" onKeyUp={this.filterSearchTerm} placeholder={T.faq.placeholder}/>
            <button className="CalipsyButton CalipsyButton-blue">{T.global.search}</button>
          </div>
          
          <div className="CalipsyFAQ-results">
            <div>{this.state.results}</div>
          </div>
        </div>
      
      </div>
    );
  }
}

export default Faq;


// WEBPACK FOOTER //
// ./src/components/Faq/index.js